export default __webpack_public_path__ + "static/media/blog-img94.675944da.jpg";